// Checkout no longer gated by a checkbox (owner request 2026-10-28)
window.lpCartConsent = { consented: function () { return true; }, ensure: function () {} };